module.exports = __webpack_public_path__ + "static/media/search.9b098f51.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svg/search.svg
// module id = 766
// module chunks = 0